import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import ErrorMessage from 'common/error';
import * as profileApi from 'api/profile';
import { useQueryClient } from 'react-query';
import { TYPE_DEVICE } from 'config/constants';



function Verify(props) {
  const queryClient = useQueryClient();
  const history = useHistory();
  const [code, setCode] = useState('');
  const [visible, setVisible] = useState(false);
  const [messageErr, setMessageErr] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code === '') {
      setAlertMessage(ErrorMessage.validate_phone);
      return false;
    }
    let data = {
      phone: props.match.params.phone,
      code: code,
      typeDevice: TYPE_DEVICE.WEB
    };
    try {
      await profileApi.verifyCodePhone(data);
      queryClient.invalidateQueries('userProfile');
      setAlertMessage('登録電話番号の変更が完了しました');
      setTimeout(() => {
        history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/account` });
      }, 2000);
    } catch (e) {
      setAlertMessage(e.response?.data?.message);
    }
  };

  const setAlertMessage = (message) => {
    setMessageErr(message);
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const showInputLine = () => {
    let array = [0, 1, 2, 3, 4, 5];
    const verifyCode = code.split('');

    return array.map((value, index) =>
      verifyCode[index] ? (
        <div
          style={{
            width: '12%',
            margin: '0px 5px 0px 5px',
            fontSize: '28px',
            display: 'flex',
            justifyContent: 'center',
          }}
          key={index}
        >
          {verifyCode[index]}
        </div>
      ) : (
        <div
          style={{
            width: '12%',
            margin: '0px 5px 0px 5px',
            height: '25px',
            borderBottom: '2px solid',
          }}
          key={index}
        ></div>
      )
    );
  };

  const setValueVerifyCode = (e) => {
    if (e.target.value.length <= 6) {
      setCode(e.target.value);
    }
  };
  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, [visible]);

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      handleSubmit();
    }
  };

  const handleNumberCharacter = (event) => {
    if (event.which === 8) return false;
    return !event.key.match(/[0-9]+/g) && event.preventDefault();
  };

  return (
    <div
      style={{
        backgroundColor: 'var(--white)',
        maxWidth: 560,
        margin: 'auto',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TopNav name={`登録電話番号変更`} hasBackIcon={true} />
      <div className="back_white_wrap align-top">
        <div>
          <div className="align-center mb-heading">
            <span className="stick-icon">&nbsp;</span>
            <span className="title font-4">登録電話番号変更</span>
          </div>
        </div>
        <div>
          <span className="title font-3">
            お送りした6桁の認証番号を入力してください。
            <br/>
            エラーになる場合は、下記のリンクから再度お試し下さい。
          </span>
        </div>
        <div style={{ position: 'relative', marginTop: 80 }}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <input
              type="number"
              style={{
                fontSize: 16,
                position: 'absolute',
                zIndex: 1000,
                opacity: 0,
                letterSpacing: '32px',
                width: '90%',
              }}
              id="name"
              name="certification_name"
              value={code}
              onKeyDown={handleNumberCharacter}
              onChange={setValueVerifyCode}
              placeholder="お送りした6桁の認証番号を入力してください。"
              onKeyUp={handleKeyUp}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 0 }}>{showInputLine()}</div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 68 }}>
          <div className="btn-main btn-submit" onClick={handleSubmit}>
            ログインする
          </div>
        </div>
        <div className="btn-link" onClick={() => history.goBack()}>
          <span className="font-2">認証番号をもう一度送る</span>
        </div>

        <Dialog
          open={visible}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ opacity: 0.6 }}
        >
          <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={handleClose}>
            <span style={{ color: 'var(--white)', fontWeight: 'bold' }}>{messageErr}</span>
          </DialogContent>
        </Dialog>
      </div>
      <BottomNav />
    </div>
  );
}

export default Verify;
